import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import Container from "@material-ui/core/Container";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { mainListItems } from "./list-items.js";
import { Route, Link } from "react-router-dom";
import { Logout } from "../../fetchs";
import Button from "@material-ui/core/Button";

import ShowMap from "../Business/ShowMap";
import EditPass from "../Users/EditPass";
import BusyList from "../businessReport/purchase-list.component";
import BussinessCategoryList from "../BussinessCategory/BussinessCategory-list.component";
import BussinessCategory from "../BussinessCategory/BussinessCategory.component";
import BusinessList from "../Business/business-list.component";
import Business from "../Business/business.component";
import UserList from "../Users/user-list.component";
import User from "../Users/user.component";
import ProductList from "../Products/product-list.component";
import Product from "../Products/product.component";
import BrandList from "../Brands/brand-list.component";
import Brand from "../Brands/brand.component";
import Categories from "../Categories/category-list.component";
import Category from "../Categories/category.component";
import SuggestionList from "../Suggestions/suggestion-list.component";
import PurchaseList from "../Purchases/purchase-list.component";
import SettingList from "../Settings/setting-list.component";
import Setting from "../Settings/setting.component";
import AgentList from "../SellAgent/agents-list.component";
import Agents from "../SellAgent/agent.component";
import Purchase from "../Purchases/purchase.component";
import SubCategoryList from "../SubCategories/sub-category-list.component";
import SubCategory from "../SubCategories/sub-category.component";
import CityList from "../Cities/city-list.component";
import City from "../Cities/city.component";
import ProvinceList from "../Province/province-list.component";
import Province from "../Province/provine.component";
import PaymentTypeList from "../PaymentTypes/payment-type-list.component";
import PaymentType from "../PaymentTypes/payment-type.component";
import VehicleBrandList from "../VehicleBrands/vehicle-brand-list.component";
import VehicleBrand from "../VehicleBrands/vehicle-brand.component";
import VehicleClassList from "../VehicleClasses/vehicle-class-list.component.js";
import vehicleClassComponent from "../VehicleClasses/vehicle-class.component.js";
import VehicleList from "../Vehicles/vehicle-list.component.js";
import Vehicle from "../Vehicles/vehicle.component";
import FestivalList from "../Festivals/festival-list.component";
import Festival from "../Festivals/festival.component";
import BookList from "../Books/book-list.component";
import Book from "../Books/book.component";
import Reminder from "../Reminder/reminder.component";
import Strings from "../Strings/strings.component";
import CityBrands from "../CityBrands/cityBrands.component.js";
import ProductPriceList from "../Products/productPrice-list.component";
import FestivalAdd from "../Products/festivall-add.component";
import ViewProduct from "../Festivals/ViewProducts";
import AdsList from "../Ads/ads-list.component";
import Ads from "../Ads/ads.component";
import CatAdsList from "../CategoryAds/categoryads-list.component";
import CatAds from "../CategoryAds/categoryads.component";
import AddCityBrand from "../CityBrands/AddCityBrand";
import CompList from "../Complimentary/comp-list.component";
import Comp from "../Complimentary/complimentary.component";
import MachineComp from "../MachineComplimentary/machine-comp.component";
import MachineCompList from "../MachineComplimentary/machinet-comp-list.component";
import "./menu.styles.css";
import BussinessCategoryComponent from "../BussinessCategory/BussinessCategory.component";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 0.5,
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Dashboard() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogout = () => {
    Logout().then((response) => {
      if (response.status === 200) window.location.href = "/login";
    });
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            پنل مدیریت
          </Typography>
          <Typography
            component="h4"
            style={{ textAlign: "left" }}
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
          >
            <Link to="/login">
              <Button
                variant="contained"
                color="secondary"
                onClick={() => localStorage.clear()}
              >
                خروج
              </Button>
            </Link>
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronRightIcon />
          </IconButton>
        </div>
        <Divider />
        <List>{mainListItems}</List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {/* bussinessCategory */}
          <Route
            exact
            path="/main/bussinesscategory"
            component={BussinessCategoryList}
          />
          <Route
            exact
            path="/main/addbussinesscategory"
            component={BussinessCategory}
          />
          <Route
            path="/main/addbussinesscategory/:id"
            component={BussinessCategory}
          />

          {/*showmap*/}
          <Route path="/main/showmap/:id" component={ShowMap} />
          {/* business */}
          <Route exact path="/main/business" component={BusinessList} />
          <Route exact path="/main/addbusiness" component={Business} />
          <Route path="/main/addbusiness/:id" component={Business} />
          {/* business */}
          <Route exact path="/main/comp" component={CompList} />
          <Route exact path="/main/addcomp" component={Comp} />
          <Route path="/main/addcomp/:id" component={Comp} />
          {/* machinecomplimentary */}
          <Route exact path="/main/machinecomp" component={MachineCompList} />
          <Route exact path="/main/addmachinecomp" component={MachineComp} />
          <Route path="/main/addmachinecomp/:id" component={MachineComp} />

          {/* CategoryAds */}
          <Route exact path="/main/adscategories" component={CatAdsList} />
          <Route exact path="/main/adscategory" component={CatAds} />
          <Route path="/main/adscategory/:id" component={CatAds} />
          {/* Ads */}
          <Route exact path="/main/adss" component={AdsList} />
          <Route exact path="/main/ads" component={Ads} />
          <Route path="/main/ads/:id" component={Ads} />

          {/* sellagents */}

          <Route path="/main/agents" component={AgentList} />
          <Route exact path="/main/sellagent" component={Agents} />
          <Route path="/main/sellagent/:key" component={Agents} />

          {/* User */}
          <Route exact path="/main/users" component={UserList} />
          <Route path="/main/users/byVisitor/:visitorId" component={UserList} />
          <Route exact path="/main/user" component={User} />
          <Route path="/main/user/:userId" component={User} />
          <Route path="/main/editpass/:userId" component={EditPass} />

          {/* Product */}
          <Route path="/main/products" component={ProductList} />
          <Route exact path="/main/product" component={Product} />
          <Route path="/main/product/:productId" component={Product} />
          <Route
            path="/main/pricebyid/:productId"
            component={ProductPriceList}
          />
          <Route path="/main/festivaladd/:productId" component={FestivalAdd} />

          {/* Brand */}
          <Route path="/main/brands" component={BrandList} />
          <Route exact path="/main/brand" component={Brand} />
          <Route path="/main/brand/:brandId" component={Brand} />

          {/* SubCategory */}
          <Route path="/main/subCategories" component={SubCategoryList} />
          <Route exact path="/main/subCategory" component={SubCategory} />
          <Route
            path="/main/subCategory/:subCategoryId"
            component={SubCategory}
          />

          {/* Category */}
          <Route path="/main/categories" component={Categories} />
          <Route exact path="/main/category" component={Category} />
          <Route path="/main/category/:categoryId" component={Category} />

          {/* City */}
          <Route path="/main/cities" component={CityList} />
          <Route exact path="/main/city" component={City} />
          <Route path="/main/city/:cityId" component={City} />

          {/* Province */}
          <Route path="/main/provinces" component={ProvinceList} />
          <Route exact path="/main/province" component={Province} />
          <Route path="/main/province/:provinceId" component={Province} />

          {/* PaymentType */}
          <Route path="/main/paymentTypes" component={PaymentTypeList} />
          <Route exact path="/main/paymentType" component={PaymentType} />
          <Route
            path="/main/paymentType/:paymentTypeId"
            component={PaymentType}
          />

          {/* Suggestion */}
          <Route path="/main/suggestions" component={SuggestionList} />
          {/* bussinessreport */}
          <Route path="/main/bussinessreport" component={BusyList} />

          {/* Purchase */}
          <Route exact path="/main/purchases" component={PurchaseList} />
          <Route
            path="/main/purchases/byCustomer/:customerId"
            component={PurchaseList}
          />
          <Route
            path="/main/purchases/byVisitor/:visitorId"
            component={PurchaseList}
          />
          <Route path="/main/purchase/:purchaseId" component={Purchase} />

          {/* Setting */}
          <Route path="/main/settings" component={SettingList} />
          <Route exact path="/main/addsetting" component={Setting} />
          <Route path="/main/addsetting/:key" component={Setting} />

          {/* VehicleBrand */}
          <Route path="/main/vehicleBrands" component={VehicleBrandList} />
          <Route exact path="/main/vehicleBrand" component={VehicleBrand} />
          <Route
            path="/main/vehicleBrand/:vehicleBrandId"
            component={VehicleBrand}
          />

          {/* VehicleClass */}
          <Route path="/main/vehicleClasses" component={VehicleClassList} />
          <Route
            exact
            path="/main/vehicleClass"
            component={vehicleClassComponent}
          />
          <Route
            path="/main/vehicleClass/:vehicleClassId"
            component={vehicleClassComponent}
          />

          {/* Vehicle */}
          <Route path="/main/vehicles" component={VehicleList} />
          <Route exact path="/main/vehicle" component={Vehicle} />
          <Route path="/main/vehicle/:vehicleId" component={Vehicle} />

          {/* Festival */}
          <Route path="/main/festivals" component={FestivalList} />
          <Route exact path="/main/festival" component={Festival} />
          <Route path="/main/festival/:festivalId" component={Festival} />
          <Route
            path="/main/viewproducts/:festivalId"
            component={ViewProduct}
          />

          {/* Book */}
          <Route path="/main/books" component={BookList} />
          <Route path="/main/book/:machineId" component={Book} />

          {/* Reminder */}
          <Route path="/main/reminder" component={Reminder} />

          {/* String */}
          <Route path="/main/string" component={Strings} />

          {/* CityBrands */}
          <Route exact path="/main/cityBrands" component={CityBrands} />
          <Route path="/main/cityBrands/:id" component={CityBrands} />
          <Route exact path="/main/addcitybrand" component={AddCityBrand} />
          <Route path="/main/addcitybrand/:id" component={AddCityBrand} />
        </Container>
      </main>
    </div>
  );
}
